import React, { Component } from "react";
import LineChartComponent from "./LineChartComponent";
import TableComponent from "./TableComponent";
import ValueDeskAndPieChartComponent from "./ValueDeskAndPieChartComponent";
import SimpleValueAndTinyChartComponent from "./SimpleValueAndTinyChartComponent";
import ValueDescAndBarChartComponent from "./ValueDescAndBarChartComponent";
import SimpleValueAndIconComponent from "./SimpleValueAndIconComponent";
import IllustrativeIconAndValueComponent from "./IllustrativeIconAndValueComponent";
import BarometerAndValueComponent from "./BarometerAndValueComponent";
import TrafficLightAndValuesComponent from "./TrafficLightAndValuesComponent";
import IllustrativeProgressBarsComponent from "./IllustrativeProgressBarsComponent";
import ComponentNotAvailable from "./ComponentNotAvailable";
import GeneratedRemarkComponent from "./GeneratedRemarkComponent";
import BarChartComponent from "./BarChartComponent";
import EmptyComponent from "./EmptyComponent";
import ValueDescComponent from "./ValueDescComponent";
import BalanceSheetComponent from "./BalanceSheetComponent";

export const COMPONENTS = {
  LINE_CHART_COMPONENT: "LINE_CHART_COMPONENT",
  BAR_CHART_COMPONENT: "BAR_CHART_COMPONENT",
  TABLE_COMPONENT: "TABLE_COMPONENT",
  VALUE_DESK_AND_PIE_CHART_COMPONENT: "VALUE_DESK_AND_PIE_CHART_COMPONENT",
  SIMPLE_VALUE_AND_TINY_CHART_COMPONENT:
    "SIMPLE_VALUE_AND_TINY_CHART_COMPONENT",
  VALUE_DESC_COMPONENT: "VALUE_DESC_COMPONENT",
  VALUE_DESC_AND_BAR_CHART_COMPONENT: "VALUE_DESC_AND_BAR_CHART_COMPONENT",
  SIMPLE_VALUE_AND_ICON_COMPONENT: "SIMPLE_VALUE_AND_ICON_COMPONENT",
  ILLUSTRATIVE_ICON_AND_VALUE_COMPONENT:
    "ILLUSTRATIVE_ICON_AND_VALUE_COMPONENT",
  BAROMETER_AND_VALUE_COMPONENT: "BAROMETER_AND_VALUE_COMPONENT",
  TRAFFIC_LIGHT_AND_VALUES_COMPONENT: "TRAFFIC_LIGHT_AND_VALUES_COMPONENT",
  ILLUSTRATIVE_PROGRESS_BARS_COMPONENT: "ILLUSTRATIVE_PROGRESS_BARS_COMPONENT",
  GENERATED_REMARK_COMPONENT: "GENERATED_REMARK_COMPONENT",
  BALANCE_SHEET_COMPONENT: "BALANCE_SHEET_COMPONENT"
};

export class ComponentFactory extends Component {
  render() {
    const { component, isComposition, ComponentCase } = this.props;

    if (
      isComposition &&
      (!component || component.data.length === 0 || component.data.error)
    ) {
      return (
        <EmptyComponent
          label={component && component.labels}
          selectedCaseProps={ComponentCase}
          {...this.props}
        />
      );
    }

    if (!component || component.data.error)
      return <ComponentNotAvailable label={component && component.labels} />;

    // eslint-disable-next-line default-case
    switch (component.type) {
      case COMPONENTS.LINE_CHART_COMPONENT:
        return <LineChartComponent {...this.props} />;

      case COMPONENTS.BAR_CHART_COMPONENT:
        return <BarChartComponent {...this.props} />;

      case COMPONENTS.TABLE_COMPONENT:
        return <TableComponent {...this.props} />;

      case COMPONENTS.VALUE_DESK_AND_PIE_CHART_COMPONENT:
        return <ValueDeskAndPieChartComponent {...this.props} />;

      case COMPONENTS.SIMPLE_VALUE_AND_TINY_CHART_COMPONENT:
        return <SimpleValueAndTinyChartComponent {...this.props} />;

      case COMPONENTS.VALUE_DESC_AND_BAR_CHART_COMPONENT:
        return <ValueDescAndBarChartComponent {...this.props} />;

      case COMPONENTS.SIMPLE_VALUE_AND_ICON_COMPONENT:
        return <SimpleValueAndIconComponent {...this.props} />;

      case COMPONENTS.ILLUSTRATIVE_ICON_AND_VALUE_COMPONENT:
        return <IllustrativeIconAndValueComponent {...this.props} />;

      case COMPONENTS.BAROMETER_AND_VALUE_COMPONENT:
        return <BarometerAndValueComponent {...this.props} />;

      case COMPONENTS.TRAFFIC_LIGHT_AND_VALUES_COMPONENT:
        return <TrafficLightAndValuesComponent {...this.props} />;

      case COMPONENTS.ILLUSTRATIVE_PROGRESS_BARS_COMPONENT:
        return <IllustrativeProgressBarsComponent {...this.props} />;

      case COMPONENTS.GENERATED_REMARK_COMPONENT:
        return <GeneratedRemarkComponent {...this.props} />;

      case COMPONENTS.VALUE_DESC_COMPONENT:
        return <ValueDescComponent {...this.props} />;

      case COMPONENTS.BALANCE_SHEET_COMPONENT:
        return <BalanceSheetComponent {...this.props} />;

      default:
        return <ComponentNotAvailable />;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Dashboard/Components/ComponentFactory.js